/**
 * Fractal Chaos Bands Calculator
 *
 * Detects fractal patterns in price data to create support/resistance bands.
 * A fractal high occurs when a bar's High is the highest among 4 surrounding bars
 * (2 on each side). A fractal low is the inverse.
 *
 * The bands hold their last detected fractal value, creating stair-step lines.
 *
 * Based on ChartIQ implementation (calcsChartIQ.js:1099-1145)
 */
export default function () {
  function calculator(data) {
    if (!data || data.length < 5) {
      return new Array(data.length).fill(undefined);
    }

    const results = [];
    let fractalHigh = 0;
    let fractalLow = 0;

    for (let i = 0; i < data.length; i++) {
      if (i < 4) {
        results.push(undefined);
        continue;
      }

      let test;
      let j;

      // Fractal High detection
      test = 0;
      for (j = 0; j <= i; j++) {
        if (!data[i - j]) break;
        if (data[i - j].high > data[i - 2].high) break;
        if (j < 2 && data[i - j].high === data[i - 2].high) break;
        if (data[i - j].high < data[i - 2].high) test++;
        if (test === 4) {
          fractalHigh = data[i - 2].high;
          break;
        }
      }

      // Fractal Low detection
      test = 0;
      for (j = 0; j <= i; j++) {
        if (!data[i - j]) break;
        if (data[i - j].low < data[i - 2].low) break;
        if (j < 2 && data[i - j].low === data[i - 2].low) break;
        if (data[i - j].low > data[i - 2].low) test++;
        if (test === 4) {
          fractalLow = data[i - 2].low;
          break;
        }
      }

      if (fractalHigh > 0 && fractalLow > 0) {
        results.push({
          fractalHigh,
          fractalLow,
        });
      } else {
        results.push(undefined);
      }
    }

    return results;
  }

  let options = {};

  calculator.undefinedLength = function () {
    return 4;
  };

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...options, ...x };
    return calculator;
  };

  return calculator;
}
